import { ReactElement } from 'react';
import {
	Headline6,
	Subtitle2,
} from '../../../../components/UI/MDC/Typography/Typography';
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import styles from './ApplicationForm.module.scss';
import RequiredIndicator from './RequiredIndicator';

/**
 * Generic input base component wrapper stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {string|ReactElement} props.label display text
 * @param {string} props.error error message
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.noIndent flag to indicate when to not increase left/right margins
 * @param {ReactElement} props.children the child components to render
 * @returns Generic input wrapper stylized for custom
 */
const AppWrappedInput = ({ label, error, isRequired, noIndent, children }) => {
	return (
		<>
			<Headline6
				className={
					error ? styles['application-form__label--invalid'] : null
				}
			>
				{isRequired ? <RequiredIndicator /> : null}
				{label}
			</Headline6>
			<StyleAuxiliary
				classes={
					noIndent
						? null
						: styles['application-form__input-indention-2']
				}
			>
				{children}
				<Subtitle2
					className={styles['application-form__label--invalid']}
				>
					{error}
				</Subtitle2>
			</StyleAuxiliary>
		</>
	);
};
export default AppWrappedInput;
